<template>
  <div>
    <div class="cloum">
      <template v-if="applyType === 'signList'">
        <!--        已拒签-->
        <template v-if="rowData.signStatus === 2">
         <span
           @click="refuseResonVisible = true"
           class="color-success"
         >查看拒签原因</span>
        </template>
        <!--未签-->
        <template v-if="rowData.signStatus === 0">
          <span
            v-if="rowData.selfSign === 1"
            @click="
              toSign()
            "
            class="color-success"
          >签署</span>
          <!--待他签-->
          <template v-else>
            <span
              v-if="rowData.isReminderSign === 1"
              class="color-success"
              @click="reminderSign(rowData)"
            >再催</span>
            <span v-else class="color-success" @click="reminderSign(rowData)">催签</span>
          </template>
          <span v-if="rowData.myCreate === 1" @click="batchCancel(rowData)" class="color-success">撤销</span>
          <span
            v-if="
              rowData.myCreate === 1 &&
              rowData.applySignCreateType !== 0 &&
              rowData.createType !== 0
            "
            @click="getNoSingInfo(rowData.applyNo)"
            class="color-success"
          >链接</span>
        </template>
        <!--审批中的操作-->
        <template v-else-if="rowData.signStatus === -3">
          <!-- 催审功能已经放到审批详情中，列表这里隐藏 （老刘的意思） 24-05-22 -->
          <!-- <template v-if="rowData.selfApprove !== 1 && rowData.fromDingTalk !==1 && !isInDingTalk">
            <span
              v-if="+rowData.isReminderApprova === 1"
              @click="urgeForTrial(rowData)"
              class="color-success"
              >已催审</span
            >
            <span
              v-if="+rowData.isReminderApprova === 0"
              @click="urgeForTrial(rowData)"
              class="color-success"
              >催审</span
            >
          </template>-->
          <span v-if="rowData.myCreate === 1" @click="batchCancel(rowData)" class="color-success">撤销</span>
          <div class="cloum" v-if="rowData.selfApprove == 1 && !isInDingTalk">
            <!--            <span @click="passAproveFn" class="color-success">同意</span>-->
            <span @click="clickHanldeAuditRefuse(1)" class="color-success">同意</span>
            <span @click="clickHanldeAuditRefuse(2)" class="color-success">拒绝</span>
          </div>
        </template>
      </template>
      <template v-else-if="applyType === 'applyList'">
        <!--        已拒签-->
        <template v-if="rowData.signStatus === 2">
         <span
           @click="refuseResonVisible = true"
           class="color-success"
         >查看拒签原因</span>
        </template>
        <template v-if="rowData.signStatus === 0">
          <template v-if="rowData.selfSign === 1">
            <span @click="
                toSign()
              " class="color-success">签署</span>
            <span @click="batchCancel(rowData)" class="color-success">撤销</span>
          </template>
          <template v-else>
            <span
              v-if="rowData.myCreate === 1"
              @click="batchCancel(rowData)"
              class="color-success"
            >撤销</span>
            <span
              v-if="rowData.isReminderSign === 1 && rowData.myCreate === 1"
              class="color-success"
              @click="reminderSign(rowData)"
            >再催</span>
            <span
              v-else-if="rowData.myCreate === 1"
              class="color-success"
              @click="reminderSign(rowData)"
            >催签</span>
            <span
              v-if="
                rowData.myCreate === 1 &&
                rowData.applySignCreateType !== 0 &&
                rowData.createType !== 0
              "
              @click="getNoSingInfo(rowData.applyNo)"
              class="color-success"
            >链接</span>
          </template>
        </template>
        <!--审批中的操作-->
        <template v-else-if="rowData.signStatus === -3">
          <span v-if="rowData.myCreate === 1" @click="batchCancel(rowData)" class="color-success">撤销</span>

          <template
            v-if="rowData.selfApprove !== 1 && rowData.myCreate === 1 && rowData.fromDingTalk !==1 && !isInDingTalk"
          >
            <span
              v-if="+rowData.isReminderApprova === 1"
              @click="urgeForTrial(rowData)"
              class="color-success"
            >已催审</span>
            <span
              v-if="+rowData.isReminderApprova === 0"
              @click="urgeForTrial(rowData)"
              class="color-success"
            >催审</span>
          </template>
        </template>
        <!--审批驳回-->
      </template>
    </div>

    <!--用户扫码签选择用户 弹窗-->
    <el-dialog
      title="获取签署链接"
      :visible.sync="visibleNoSignList"
      modal-append-to-body
      append-to-body
      :close-on-click-modal="false"
      :show-close="true"
      width="550px"
      custom-class="my-dialog"
    >
      <!--      <el-row v-if="noSign.data">-->
      <!--        <el-col v-for="(item, index) in noSign.data" :span="8" :key="index" style="margin-bottom: 10px;"-->
      <!--                class="font-ellipsis">-->
      <!--          <a @click="getNoSignUrl(item)" :title="item.fullName" href="javascript:void (0)" class="color-success">{{item.fullName-->
      <!--            | ellipsis(8)}}</a>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <div class="flex">
        <el-select
          :value="noSign.signNo"
          @input="
            (val) => {
              dselect(val);
            }
          "
          placeholder="选择待签署方"
        >
          <el-option
            class="my-dialog-select"
            v-for="item in noSign.data"
            :key="item.signNo"
            :label="item.fullName"
            :value="item.signNo"
          ></el-option>
        </el-select>
        <!--        <el-button class="a-btn ml10" @click="getNoSignUrl(noSign.signNo)">获取ta的二维码和链接</el-button>-->
      </div>
      <div class="flex" style="margin: 15px auto">将下方二维码或链接复制发送给对方，即可进行签署。</div>
      <div class="flex dashed">
        <div class="box">
          <div class="qrcode">
            <qrcode v-if="showQy" :value="noSign.url" :size="140" leave="H" key="evidence" />
            <span v-else class="ne-text">请先选择签署方</span>
          </div>
          <el-button class="b-btn" :disabled="!showQy" @click="saveQr">保存二维码</el-button>
        </div>
        <div class="box">
          <div style="padding: 10px; box-sizing: border-box">
            <template v-if="showQy">{{ noSign.url }}</template>
            <span v-else class="ne-text">请先选择签署方</span>
          </div>
          <el-button
            class="b-btn"
            :disabled="!showQy"
            id="tag-copy"
            :data-clipboard-text="noSign.url"
            @click="copyText($event)"
          >复制签署链接</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 拒绝原因 Dialog -->
    <el-dialog :visible.sync="dialogAuditRefuseVisible" :title="refuseModel.flowStatus === 2 ? '拒绝原因' : '审批意见'" width="500px">
      <el-row>
        <el-col :span="24">
          <div style="position: relative">
            <el-input
              ref="textareaReasonRef"
              type="textarea"
              v-model="refuseModel.reason"
              rows="5"
              resize="none"
              :autofocus="true"
              size="small"
              :maxlength="100"
              :placeholder="refuseModel.flowStatus === 2 ? '请输入拒绝原因' : '请输入审批意见'"
            />
            <span
              style="position: absolute; bottom: 10px; right: 10px; color: red"
            >{{ refuseModel.reason.length }}/100</span>
          </div>
        </el-col>
        <el-col :span="24" style="height: 24px">
          <p v-if="refuseModel.errorMessage" style="color: red">{{ refuseModel.errorMessage }}</p>
        </el-col>
      </el-row>
      <p slot="footer" class="dialog-footer">
        <el-button @click="dialogAuditRefuseVisible = false" size="small" class="btn">取消</el-button>
        <el-button @click="clickHandleRefuseSubmit()" type="danger" size="small" class="btn">提交</el-button>
      </p>
    </el-dialog>
    <!--    refuseResonVisible 拒签原因 -->
    <el-dialog
      title="拒签原因"
      :visible.sync="refuseResonVisible"
      width="30%">
      <div>
        <p>签约方：{{rowData.signInfoVOS && rowData.signInfoVOS.length ? rowData.signInfoVOS[0].signatoryFullName : '--'}}</p>
        <div>拒签原因：{{rowData.signInfoVOS && rowData.signInfoVOS.length ? rowData.signInfoVOS[0].refuseReason : '--'}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="refuseResonVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  ApiCorpMethods,
  signViewUrl,
  applyViewUrl,
  signAudit,
  applyAudit,
  noSignList,
  noSignUrl
} from "@/assets/js/http-serve/corp/http-methods";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import Qrcode from "qrcode.vue";
import Clipboard from "clipboard";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  name: "corpHandles",
  components: {
    Qrcode
  },
  props: {
    rowData: {
      type: Object
    },
    applyType: {
      type: String
    }
  },
  data () {
    return {
      isInDingTalk,
      // 合同没有签署的签署方信息和url
      noSign: { data: null, url: "", name: "", signNo: "" },
      visibleNoSignList: false,
      dialogAuditRefuseVisible: false,
      refuseModel: {
        flowStatus: "",
        reason: "",
        errorMessage: "",
      },
      refuseResonVisible: false,
    };
  },
  methods: {
    // 审批拒绝
    clickHanldeAuditRefuse (type) {
      this.refuseModel.reason = "";
      this.refuseModel.flowStatus = type;
      this.refuseModel.errorMessage = "";
      this.dialogAuditRefuseVisible = true;
      // this.$nextTick(() => {
      //   if (this.$refs.textareaReasonRef) {
      //     this.$refs.textareaReasonRef.focus();
      //   }
      // });
    },
    // 审批拒绝 提交拒绝原因
    clickHandleRefuseSubmit () {
      if (this.refuseModel.flowStatus === 1) {
        this.executeAudit();
      } else if (this.refuseModel.flowStatus === 2) {
        this.handleBlur();
        if (!this.refuseModel.errorMessage) {
          this.executeAudit();
        }
      }

    },
    // 拒绝原因失去焦点事件
    handleBlur () {
      let v = this.refuseModel.reason;
      if (v) {
        if (v.length > 100) {
          this.refuseModel.errorMessage = "不能超过100个字";
        } else {
          this.refuseModel.errorMessage = "";
        }
      } else {
        this.refuseModel.errorMessage = "请输入拒绝原因审批意见";
      }
    },
    // 提交审核结果
    executeAudit () {
      let params = {
        applyNo: this.rowData.applyNo,
        approveId: this.rowData.approveId,
        multiFile: this.rowData.multiFile,
        aiCorpUserIdFlag: this.rowData.aiCorpUserIdFlag,
        flowStatus: this.refuseModel.flowStatus,
        reason: this.refuseModel.reason
      };
      // console.info(params)
      ApiCorpMethods.CorpAuditContractController.approveFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.dialogAuditRefuseVisible = false;
            this.$message.success('操作成功');
            this.$emit('resetList')
            // if (!isInDingTalk) {
            //   window.opener ? window.opener.location.reload() : window.close();
            // }
          } else {
            this.$message.error(res.description || "审批驳回");
          }
        })
        .catch(error => {
          this.$message.error(error.description || "审批驳回");
        });
    },
    // 获取合同没有签署的签署方信息
    getNoSingInfo (applyNo) {
      if (!applyNo) return;
      noSignList({ applyNo: applyNo }).then(({ data }) => {
        this.noSign.data = data || null;
        this.visibleNoSignList = true;
      });
    },
    // 复制
    copyText () {
      const clipboard = new Clipboard("#tag-copy");
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    // 下载二维码
    saveQr () {
      let canvas = document.querySelector(".qrcode canvas");
      let imgUrlBase64 = canvas.toDataURL("image/png");
      if (window.navigator.msSaveOrOpenBlob) {
        // ie
        let bstr = atob(imgUrlBase64.split(",")[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "二维码" + "." + "png");
      } else {
        let oA = document.createElement("a");
        oA.download = "二维码.png";
        oA.href = imgUrlBase64;
        document.body.appendChild(oA);
        oA.click();
        oA.remove();
      }
    },
    getNoSignUrl (signNo) {
      if (!signNo) return;
      noSignUrl(signNo).then(({ data }) => {
        if (data) {
          this.noSign.url = data;
        }
      });
    },
    dselect (val) {
      this.noSign.signNo = val;
      this.noSign.data.map(item => {
        if (item.signNo == val) {
          this.noSign.name = item.fullName;
        }
      });
      this.getNoSignUrl(val);
    },
    async onGetCerti () {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: this.rowData.signNo || "",
        applyNo: this.rowData.applyNo || ""
      };
      let viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        _this.openCSDialog(certiRes.data);
      } else {
        let certiListRes = await ApiMethods.ApplySignController.certiList(
          _param
        );
        if (certiListRes.success) {
          if (!certiListRes.data || certiListRes.data.lengt == 0)
            return _this.$message.error("初始化数据失败");
          if (certiListRes.data.length === 1)
            return _this.openCSDialog(certiListRes.data[0]);
          if (certiListRes.data.length > 1)
            return _this.openSSDialog(certiListRes.data);
        } else {
          _this.$message.error(certiListRes.description);
        }
      }
    },
    openCSDialog (data) {
      this.$emit("setCSDialogData", {
        cSDialogVisible: true,
        cSDialogData: data
      });
    },
    openSSDialog (data) {
      this.$emit("setSSDialogData", {
        sSDialogVisible: true,
        sSDialogData: {
          certData: data
        }
      });
    },
    // 前往签署
    toSign () {
      const { signNo, applyNo, approveId, multiFile, aiCorpUserIdFlag, fromDingTalk } = this.rowData;
      // 判断是否国际版发起的合同，如果不是就提示去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
      if((applyNo && applyNo.startsWith('APLO'))){
        return this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
      }
      ApiCorpMethods.UserApplySignController.postSignUrl(signNo)
        .then(res => {
          if (res.success) {
            let new_window = null;
            if (!isInDingTalk) new_window = window.open("", "_blank");
            res.data.approveId = approveId;
            let router = multiFile
              ? this.$router.resolve({
                path: "/initiation/viewDetail",
                query: {
                  ...res.data,
                  aiCorpUserIdFlag: aiCorpUserIdFlag
                }
              })
              : this.$router.resolve({
                path: "/signInfo/viewDetail",
                query: {
                  ...res.data,
                  aiCorpUserIdFlag: aiCorpUserIdFlag
                }
              });
            let href = window.location.origin + router.href;
            if (isInDingTalk) {
              this.$router.push({ path: router.href });
            } else {
              new_window.location.href = href;
            }
            // 设置token
            localStorage.setItem("JZQ_SIGN_TOKEN_KEY", res.data.tokenKey);
            localStorage.setItem("JZQ_SIGN_TOKEN", res.data.token);
          } else {
            // new_window.close();
            if (res.code === "11016") {
              this.$confirm(
                '<p style="font-size: 16px;">是否继续？</p><p style="font-size: 12px;color: #a2a2a2; line-height: 20px;">您没有用章权限，仅能查看文件内容，如需签署请联系企业管理员获取用章权限。如您是管理员，请前往企业控制台“印章及授权”菜单，将需要使用的印章授权给自己。</p>',
                {
                  distinguishCancelAndClose: true,
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              )
                .then(() => {
                  this.toApplyDetail();
                })
                .catch(() => { });
            } else {
              this.$message.error(res.description);
            }
          }
        })
        .catch(err => {
          // new_window.close();
          console.log(err);
          this.$confirm(err.description, "系统提示", {
            confirmButtonText: "确定",
            type: "warning"
          }).then(() => { });
        });
    },
    // 前往合同详情
    toApplyDetail () {
      console.log('this.rowData', this.rowData);
      const { signNo, applyNo, approveId, multiFile, aiCorpUserIdFlag, fromDingTalk } = this.rowData;
      if (isInDingTalk && !fromDingTalk && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往君子签Web端处理！')
      if (!isInDingTalk && (fromDingTalk && fromDingTalk === 1) && this.signInfo.signStatus === -3) return this.$message.warning('当前合同请前往钉钉微应用处理！');
      let param = {
        signNo,
        applyNo,
        approveId: approveId || '',
        multiFile
      };
      let newWindow = null;
      if (this.applyType === 'iApplyList') {
        param.corpQuery = 1;
      }
      // 两种接口（发起、收到）
      this.viewUrl(param)
        .then(url => {
          if (this.applyType === "iApplyList") {
            let data = url.data;
            let newWindow;
            if (!isInDingTalk) newWindow = window.open();
            let path = this.signInfo.multiFile
              ? "/applySign/toDetailMultiAnony"
              : "/applySign/toDetailAnony";
            data.approveId = approveId;
            let router = this.$router.resolve({ path: path, query: data });
            let href = window.location.origin + router.href;
            // 如果是钉钉环境就走 location 不要 window.open
            isInDingTalk ? this.$router.push(url) : newWindow.location.href = href
          } else {
            if (!isInDingTalk) newWindow = window.open();
            const path = aiCorpUserIdFlag
              ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
              : url;
            isInDingTalk ? this.$router.push(url) : newWindow.location.href = path
          }
        })
        .catch(err => {
          if (!isInDingTalk) {
            newWindow.close();
            console.error("toApplyDetail: " + JSON.stringify(err));
          }
        });
    },
    toAudit ({ applyNo, signNo, approveId, multiFile, aiCorpUserIdFlag }) {
      let param = {
        signNo: signNo,
        applyNo: applyNo,
        approveId: approveId,
        multiFile: multiFile
      };

      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      signAudit(param)
        .then(url => {
          let href = aiCorpUserIdFlag
            ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
            : url;
          isInDingTalk ? location.href = href : newWindow.location.href = href
        })
        .catch(err => {
          if (!isInDingTalk) newWindow.close();
          console.error("toAudit: " + JSON.stringify(err));
        });
    },
    toApplyAudit ({ applyNo, signNo, approveId, multiFile, aiCorpUserIdFlag }) {
      var param = {
        signNo: signNo,
        applyNo: applyNo,
        approveId: approveId,
        multiFile: multiFile
      };
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();
      applyAudit(param)
        .then(url => {
          let href = aiCorpUserIdFlag
            ? url + "&aiCorpUserIdFlag=" + aiCorpUserIdFlag
            : url;
          isInDingTalk ? location.href = href : newWindow.location.href = href
        })
        .catch(err => {
          if (!isInDingTalk) newWindow.close();
          console.error("toAudit: " + JSON.stringify(err));
        });
    },
    batchCancel: function (item) {
      const batchText = item ? "合同撤销后，原合同将无法再签署，确定撤销？" : "确定删除";
      let ids = [],
        dels = item ? [item] : [];
      for (let i = 0; i < dels.length; i++) {
        ids.push(dels[i].applyId);
      }
      if (ids.length < 1) {
        return this.$alert("你还未选择要操作的数据", "系统提示");
      }
      this.$confirm(batchText, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ApiCorpMethods.UserApplySignController.batchCancel({
            applyIds: ids.join(",")
          }).then(result => {
            if (result.success) {
              this.$message.success(result.description || "操作成功");
              this.$emit("resetList");
            } else {
              this.$message.error(result.description || this.$tip);
            }
          });
        })
        .catch(() => { });
    },

    // 20210129 新增集团催签
    // 催签
    reminderSign (sign) {
      var param = {
        applyId: sign.applyId || null
      };
      ApiCorpMethods.SendSms4SignController.reminderSign(param)
        .then(res => {
          // data参数：{cashierUrl:'', money: '', orderNumber: '', point: ''}
          var data = res.data;
          if (!data.needPay) {
            return this.$message.success("催签成功");
          }
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `<div style="font-weight: bold;color: #606266;font-size: 18px;text-align: center;border: 1px dashed #FCE2E2;padding-bottom: 5px ">
                            <img src="/images/icon_signed.png" style="height: 80px">
                            <p style="margin-top: 10px">需花费：
                            <span style="color: #Ec1C1C">${data.point}积分/次</span></p>
                            <p style="margin-top: 10px;padding: 0 10px;font-weight: 400;font-size: 14px;text-align: start">
                            <i class="el-icon-info" style="margin-right: 5px"></i>
                            确定后，未签署的签约方将收到催签短信通知，此通知72小时有效。</p></div>`,
                "温馨提示",
                {
                  showConfirmButton: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  customClass: "handle-message"
                  // type: 'info',
                }
              ).then(() => {
                ApiCorpMethods.SendSms4SignController.reminderSign(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.$emit("resetList");
                    return this.$message.success("催签成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    // 20210304 新增集团催审
    urgeForTrial (sign) {
      var param = {
        applyId: sign.applyId || null
      };
      ApiCorpMethods.SendSms4SignController.reminderApprova(param)
        .then(res => {
          // data参数：{cashierUrl:'', money: '', orderNumber: '', point: ''}
          var data = res.data;
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `<div style="font-weight: bold;color: #606266;font-size: 18px;text-align: center;border: 1px dashed #FCE2E2;padding-bottom: 5px ">
                            <img src="/images/icon_signed.png" style="height: 80px">
                            <p style="margin-top: 10px">需花费：
                            <span style="color: #Ec1C1C">${data.point}积分/次</span></p>
                            <p style="margin-top: 10px;padding: 0 10px;font-weight: 400;font-size: 14px;text-align: start">
                            <i class="el-icon-info" style="margin-right: 5px"></i>
                            确定后，待审批的审批方将收到审批短信通知，该通知72小时有效</p></div>`,
                "温馨提示",
                {
                  showConfirmButton: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  customClass: "handle-message"
                  // type: 'info',
                }
              ).then(() => {
                ApiCorpMethods.SendSms4SignController.reminderApprova(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.$emit("resetList");
                    return this.$message.success("催审成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    }
  },
  computed: {
    viewUrl () {
      if (this.applyType === "signList") {
        return signViewUrl;
      } else if (this.applyType === "applyList") {
        return applyViewUrl;
      } else if (this.applyType === "iApplyList") {
        return ApiMethods.UserApplySignController.viewUrl;
      }
    },
    showQy () {
      return !!this.noSign.url;
    }
  }
};
</script>

<style lang="less" scoped>
.cloum {
  display: flex;
  /*flex-direction: column;*/
}
.a-btn {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  text-decoration: none;
  height: 30px;
  min-width: 130px;
  padding: 0;
  color: #ec1c1c;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 4px;

  &:focus {
    color: #ec1c1c;
    border: 1px solid rgba(236, 28, 28, 1);
  }

  &:hover {
    background-color: #ec1c1c;
    color: rgba(255, 255, 255, 1);
  }

  &.is-disabled {
    background-color: #cccccc;
    color: rgba(255, 255, 255, 1);
    border: transparent;
  }
}

.b-btn {
  .a-btn();
  background-color: #ec1c1c;
  color: rgba(255, 255, 255, 1);
  &:hover {
    opacity: 0.7;
  }
  &:focus {
    background-color: #ec1c1c;
    color: rgba(255, 255, 255, 1);
  }
}
.ne-text {
  top: 20px;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  color: #cccccc;
}
.my-dialog-select {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  padding: 0 10px;

  &.el-select-dropdown__item.hover,
  &.el-select-dropdown__item:hover {
    background-color: #ffe6e6;
    color: #ec1c1c;
  }
}
/deep/ .my-dialog {
  .el-dialog__header {
    padding: 0 20px;
    line-height: 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 0px 6px rgba(243, 203, 203, 0.3);
    opacity: 1;
    border-radius: 2px 2px 0px 0px;

    .el-dialog__title {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }

    .el-icon {
      color: #8c8c8c;
    }

    .el-dialog__headerbtn {
      top: 8px;
    }
  }

  .el-dialog__body {
    box-shadow: 3px 0px 6px rgba(243, 203, 203, 0.3);
    background: rgba(255, 255, 255, 1);
    padding: 40px 20px 30px 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 440px;
    margin: 0 auto;

    .el-select {
      flex: auto;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        padding: 0 20px 0 10px;
        /*border:1px solid rgba(216,216,216,1);*/
        opacity: 1;
        border-radius: 2px;
      }
      .el-input__suffix {
        right: 1px;
        top: 50%;
        margin-top: -13px;
      }
      .el-input__suffix-inner {
        background-color: #ffe9e9;
      }
      .el-input__icon {
        width: 20px;
        line-height: 26px;
        color: #ec1c1c;
      }
    }
  }

  .dashed {
    border: 1px dashed rgba(236, 28, 28, 0.3);
    border-radius: 4px;
    /*margin-top:30px;*/
    padding: 20px 0;
    justify-content: space-around;

    .box {
      text-align: center;
      > div {
        font-size: 14px;
        background: rgba(248, 248, 248, 1);
        opacity: 1;
        border-radius: 2px;
        width: 150px;
        height: 150px;
        overflow-y: auto;
        margin-bottom: 10px;
        text-align: left;
        position: relative;
      }

      .qrcode /deep/ canvas {
        position: absolute;
        /*width: 140px !important;*/
        /*height:140px !important;*/
        left: 50%;
        top: 50%;
        margin-left: -70px;
        margin-top: -70px;
      }
    }
  }
}
.color-success {
  margin-right: 8px;
  cursor: pointer;
  color: #290202;
  font-weight: bold;
}
.color-success:hover {
  color: #ec1c1c;
}
</style>



// WEBPACK FOOTER //
// components/apply-list/corpHandles.vue